export const home = "/";
export const about = "/about";
export const projects = "/projects";
export const links = "/links";
export const work = "/work";
export const mines = "/mines";
export const games = "/games";
export const individualgame = "/games/:gameID"